import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[appDragDrop]',
    standalone: false
})
export class DragDropDirective {

  constructor() { }

  @Output() onFileDroppedEvent = new EventEmitter<any>();
  @Output() onDragOverEvent = new EventEmitter<any>();
  @Output() onDragLeaveEvent = new EventEmitter<any>();

  @HostListener('dragover', ['$event']) onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.onDragOverEvent.emit();
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.onDragLeaveEvent.emit();
  }

  @HostListener('drop', ['$event']) public onDrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    let files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.onFileDroppedEvent.emit(files)
    }
  }

}
